import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.jsx';
import { brandConfig, logo, theme } from './brands/runport';
import { initSentry } from './config/sentry';

initSentry();

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App brandConfig={brandConfig} theme={theme} logo={logo} />
  </StrictMode>
);
